$(document).ready(function() {
  $(".acf-region-select [title!=''][title]").click(function(e) {
    const target = $(this);
    let title = target.attr("title");

    if (!target.hasClass("no-stroke")) {
      const self = target.closest(".js-region");
      const select = self.find(".region-select");
      const traders = self.find(".traders");
      const mapTargets = self.find(".acf-region-select [title!=''][title]");
      const selectedOption = self.find(
        '.region-select option[value="' + title + '"]'
      );

      mapTargets.removeClass("active");
      traders.hide();

      if (selectedOption.length !== 0) {
        select.val(title);
        traders.filter("." + title.replaceAll(" ", "-")).show();
        target.addClass("active");
      } else {
        select.val("blank");
        traders.filter(".blank").show();
      }
    }
  });

  $(".region-select").change(function() {
    const select = $(this);
    const self = select.closest(".js-region");
    const mapTargets = self.find(".acf-region-select [title!=''][title]");
    const traders = self.find(".traders");
    const title = select.val();
    const mapTarget = mapTargets.filter("[title='" + title + "']");

    mapTargets.removeClass("active");
    mapTarget.addClass("active");
    traders.hide();
    traders.filter("." + title.replaceAll(" ", "-")).show();
  });
});
